export default {
  props: ['isShow'],
  watch: {
    isShow (nv, ov) {
      if (nv && !ov) {
        this.startShow && this.startShow()
      }
    }
  }
}
